import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import DashboardTwo from './DashboardTwo';
import Cookies from "./CokiesTable";
import ChatUpdate from "./ChatUpdate";
import Other from "./Other";
import MailUpdate from "./EmailUpdate";
import ProductUpdate from "./ProductUpdate";
import NewsUpdate from "./NewsUpdate";
import EventUpdate from "./EventUpdate";
import { useCallback } from 'react';
import Complance from "./Complanceupdate";
import PDF from "./PDFUpdate";
import RelatedDocument from "./Related-Document";
import Register from '../Register';


// Component Mapping
const componentMap = {
  'Dashboard': (onSelect) => <DashboardTwo onSelect={onSelect} />,
  'Media Update': () => <NewsUpdate />,
  'Events Update': () => <EventUpdate />,
  'Compliance Update': () => <Complance />,
  'Product Update': () => <ProductUpdate />,
  'PDF Update': () => <PDF />,
  'Related Document': () => <RelatedDocument />,
  'Update Group': () => <ChatUpdate />,
  'Update Mail': () => <MailUpdate />,
  'ON/OFF Cookies': () => <Other />,
  'Cookies Data': () => <Cookies />,
  'Admin Registration':() => <Register/>
};

const SidebarDashboard = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState('Dashboard');
  const [activeComponent, setActiveComponent] = useState(componentMap['Dashboard'](setActiveByName));
  const [username, setUsername] = useState(''); // ✅ State for Username
  const [isLoggingOut, setIsLoggingOut] = useState(false); // ✅ Logout state for animation
  const [showUsername, setShowUsername] = useState(false);
  const [countdown, setCountdown] = useState(1800); // ✅ 30 minutes countdown in seconds

  // ✅ Function to Set Active Component
  function setActiveByName(name) {
    setActiveComponent(componentMap[name](setActiveByName));
    setActiveItem(name);
  }

  // ✅ Redirect to Login if User is Not Authenticated
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const storedUsername = localStorage.getItem('username'); // Retrieve username
    if (!token) {
      navigate('/');
    } else {
      setUsername(storedUsername || ''); // Set username if available
    }
  }, [navigate]);

  // ✅ Logout with Spinner Animation
  const handleLogout = useCallback(() => {
    setIsLoggingOut(true); // Show loading animation

    setTimeout(() => {
      localStorage.removeItem('authToken'); // Remove token
      localStorage.removeItem('username');  // Remove username
      navigate('/login'); // Redirect to login page
    }, 2000); // Wait 2 seconds before logout
  }, [navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(prevCountdown => {
        if (prevCountdown <= 1) {
          clearInterval(interval);
          handleLogout(); // Auto logout when countdown reaches 0
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [handleLogout]);

  return (
    <div className="min-h-screen flex w-full">
      {/* Sidebar */}
      <div className="w-[282px] text-white p-6">
        <h2 className="mb-8 text-2xl font-bold whitespace-nowrap">
          Welcome : {username || 'User'} {/* ✅ Display Username Dynamically */}
        </h2>

        <ul className="space-y-2 mt-10">
          {Object.keys(componentMap).map((item) => (
            <motion.li
              key={item}
              className={`p-3 text-lg font-medium cursor-pointer rounded-lg transition-all ${
                activeItem === item ? 'bg-blue-500 text-white shadow-lg' : 'hover:bg-blue-400 hover:text-white'
              }`}
              onClick={() => setActiveByName(item)}
              whileHover={{ scale: 1.05 }}
            >
              {item}
            </motion.li>
          ))}
        </ul>
      </div>

      {/* Main Content Area */}
      <div className="w-full p-6">
        <div className="flex justify-end items-center gap-4 mb-6">
         
        <div className="flex flex-col items-center">
        <button 
            className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-600"
            onClick={() => setShowUsername(!showUsername)} // ✅ Toggle Username
          >
            Information
          </button>
          {/* ✅ Show Username Below Profile Button When Clicked */}
          {showUsername && (
            <div className=" text-white text-lg px-1 overflow-hidden fixed mt-11 ml-16">
              {username}<br/>
            <span className="animate-pulse">  {countdown} : Seconds Left </span>
            </div>
          )}
          </div>
          {/* Logout Button with Spinner Animation */}
          <button 
            className="bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-red-600 flex items-center justify-center w-[100px]"
            onClick={handleLogout}
            disabled={isLoggingOut} // Disable button while logging out
          >
            {isLoggingOut ? (
              <div className="w-6 h-6 border-4 border-white border-dashed rounded-full animate-spin"></div>
            ) : (
              "Logout"
            )}
          </button>
        </div>

        {/* Render Active Component */}
        <div className="rounded-2xl p-2">
          {activeComponent}
        </div>
      </div>
    </div>
  );
};

export default SidebarDashboard;
